import React from 'react'
import constants from '../data/constants'
import {Col, Container, Row} from 'reactstrap'

const Footer = () => (
    <Container>
        <Row>
            <Col md={{size: 6, offset: 3}}>
                <h3>Complete Developer Podcast</h3>
            </Col>
        </Row>
        <Row>
            <Col md={{size: 6, offset: 3}}>
                <div className="footer-social-links">
                    <ul className="social-links-list">Follow us on social media
                        <li>
                            <a href={constants.facebookUrl} target="_blank" rel="noopener noreferrer" className="facebook">
                                <i className="fab fa-facebook-f fa-2x"></i>
                            </a>
                        </li>
                        <li>
                            <a href={constants.twitterUrl} target="_blank" rel="noopener noreferrer" className="twitter">
                                <i className="fab fa-twitter fa-2x"></i>
                            </a>
                        </li>
                        <li>
                            <a href={constants.linkedInUrl} target="_blank" rel="noopener noreferrer" className="linkedin">
                                <i className="fab fa-linkedin-in fa-2x"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </Col>
        </Row>
    </Container>
   
)

export default Footer